__turbopack_context__.v({
  "colContact": "Footer-module-scss-module__W8gHqG__colContact",
  "colHeading": "Footer-module-scss-module__W8gHqG__colHeading",
  "colLogo": "Footer-module-scss-module__W8gHqG__colLogo",
  "colNewsletter": "Footer-module-scss-module__W8gHqG__colNewsletter",
  "columns": "Footer-module-scss-module__W8gHqG__columns",
  "contactItem": "Footer-module-scss-module__W8gHqG__contactItem",
  "contactLabel": "Footer-module-scss-module__W8gHqG__contactLabel",
  "contactNumber": "Footer-module-scss-module__W8gHqG__contactNumber",
  "copyright": "Footer-module-scss-module__W8gHqG__copyright",
  "emailInput": "Footer-module-scss-module__W8gHqG__emailInput",
  "emailRow": "Footer-module-scss-module__W8gHqG__emailRow",
  "footer": "Footer-module-scss-module__W8gHqG__footer",
  "formError": "Footer-module-scss-module__W8gHqG__formError",
  "formSuccess": "Footer-module-scss-module__W8gHqG__formSuccess",
  "inner": "Footer-module-scss-module__W8gHqG__inner",
  "logo": "Footer-module-scss-module__W8gHqG__logo",
  "phoneIcon": "Footer-module-scss-module__W8gHqG__phoneIcon",
  "socialIcon": "Footer-module-scss-module__W8gHqG__socialIcon",
  "socialRow": "Footer-module-scss-module__W8gHqG__socialRow",
  "subscribeBtn": "Footer-module-scss-module__W8gHqG__subscribeBtn",
  "tagline": "Footer-module-scss-module__W8gHqG__tagline",
  "topDivider": "Footer-module-scss-module__W8gHqG__topDivider",
});
